import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer-top" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "footer-nav" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "footer-nav" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "footer-social" }
const _hoisted_16 = { class: "social" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon-social-square-fb" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "icon-social-square-li" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "footer-bottom" }
const _hoisted_24 = { class: "width-wrap" }
const _hoisted_25 = { class: "footer-copy" }
const _hoisted_26 = ["href", "title"]
const _hoisted_27 = ["href", "title"]
const _hoisted_28 = ["href", "title"]
const _hoisted_29 = { class: "footer-logo" }
const _hoisted_30 = ["href", "title"]
const _hoisted_31 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.ABOUT_US_URL
              }, _toDisplayString(_ctx.$t('TheFooter.about-us')), 9, _hoisted_5)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.INFORMATION_ABOUT_NEW_FEATURES_URL
              }, _toDisplayString(_ctx.$t('TheFooter.information-about-new-features')), 9, _hoisted_6)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.CAREER_URL
              }, _toDisplayString(_ctx.$t('TheFooter.career')), 9, _hoisted_7)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.ADVERTISING_URL
              }, _toDisplayString(_ctx.$t('TheFooter.advertising')), 9, _hoisted_8)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.CONTACT_URL
              }, _toDisplayString(_ctx.$t('TheFooter.contact')), 9, _hoisted_9)
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_10, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.INVESTOR_INFORMATION_URL
              }, _toDisplayString(_ctx.$t('TheFooter.investor-information')), 9, _hoisted_11)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.PRIVACY_URL
              }, _toDisplayString(_ctx.$t('TheFooter.privacy')), 9, _hoisted_12)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.GENERAL_TERMS_URL
              }, _toDisplayString(_ctx.$t('TheFooter.general-terms')), 9, _hoisted_13)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.config.COMPLAINT_URL
              }, _toDisplayString(_ctx.$t('TheFooter.complaint')), 9, _hoisted_14)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('TheFooter.find-us')), 1),
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("a", {
              href: _ctx.config.FACEBOOK_URL,
              target: "_blank",
              class: "fb"
            }, _hoisted_19, 8, _hoisted_17),
            _createElementVNode("a", {
              href: _ctx.config.LINKEDIN_URL,
              target: "_blank",
              class: "linkedin"
            }, _hoisted_22, 8, _hoisted_20)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(new Date(), 'yyyy')) + " © " + _toDisplayString(_ctx.domain) + ". All rights reserved.", 1),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              class: "external",
              href: _ctx.$t('copyright.links.alejtech-webdesign'),
              target: "_blank",
              rel: "noopener",
              title: _ctx.$t('copyright.open-new-window')
            }, _toDisplayString(_ctx.$t('copyright.webdesign')), 9, _hoisted_26),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('copyright.and')), 1),
            _createElementVNode("a", {
              class: "external",
              href: _ctx.$t('copyright.links.kabernet'),
              target: "_blank",
              rel: "noopener",
              title: _ctx.$t('copyright.open-new-window')
            }, _toDisplayString(_ctx.$t('copyright.cms')), 9, _hoisted_27),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('copyright.from')), 1),
            _createElementVNode("a", {
              href: _ctx.$t('copyright.links.alejtech'),
              title: _ctx.$t('copyright.open-new-window'),
              target: "_blank",
              rel: "noopener",
              class: "external"
            }, "AlejTech, spol. s r.o.", 8, _hoisted_28)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("a", {
            href: _ctx.$t('copyright.links.kabernet'),
            target: "_blank",
            rel: "noopener",
            title: _ctx.$t('copyright.open-new-window')
          }, [
            _createElementVNode("img", {
              src: _ctx.kabernetLogoUrl,
              alt: _ctx.$t('copyright.webdesign'),
              width: "105",
              height: "24"
            }, null, 8, _hoisted_31)
          ], 8, _hoisted_30)
        ])
      ])
    ])
  ]))
}